import * as React from 'react';
import { ethers } from 'ethers';
import { NftCard } from './NftCard';
import { MintList } from './MintList';

export function Cart(props) {
  const [value, setValue] = React.useState();
  const [ethValue, setEthValue] = React.useState();

  React.useEffect(() => {
    let qty = props.cart.length;
    let big = props.bigPrice;
    let bigPrice = ethers.BigNumber.from(big || 0);
    let bigQty = ethers.BigNumber.from(qty || 0);
    let totalValue = bigQty.mul(bigPrice);
    let value = ethers.utils.formatUnits(totalValue, 'wei');
    setValue(value);
    let ethVal = ethers.utils.formatUnits(totalValue, 'ether');
    setEthValue(ethVal);
  }, [props.cart, props.bigPrice]);

  return (
    <>
      <div className='grid grid-cols-3 md:grid-cols-5 xl:grid-cols-8 gap-4'>
        {props.cart &&
          props.cart.map((id) => (
            <NftCard
              key={id}
              id={id}
              removeFromCart={props.removeFromCart}
              cart={props.cart}
              inCart={props.inCart}
              bigPrice={props.bigPrice}
              inCartStatus={props.inCartStatus}
            />
          ))}
      </div>
      <MintList
        cart={props.cart}
        value={value}
        connected={props.connected}
        eth={ethValue}
        resetCart={props.resetCart}
      />
    </>
  );
}
